import * as TransactionsActions from '../actions/transactions.actions';
import * as systemActions from 'src/app/store/system/actions/system.actions';
import { initialTransactionsState, initialTransactionStates, ITransactionsState, ITransactionStates } from '../../state/transactions-state';
import { transactionAdapter } from '../selectors/transactions.selectors';
import { ITransactionSearchResult } from 'src/app/models/transactions';
import { ActionReducerMap } from '@ngrx/store';

export const TransactionsReducers: ActionReducerMap<ITransactionStates> = {
    cash: CashTransactionsReducer,
    securities: SecurityTransactionsReducer,
    revenue: RevenueTransactionsReducer
}

export function CashTransactionsReducer(
    state = initialTransactionsState, action: TransactionsActions.CashTransactionsActions | systemActions.SystemActions): ITransactionsState {
    switch (action.type) {
        case systemActions.CLEAR_SYSTEM:
        case TransactionsActions.TransactionsActionTypes.RESET_CASH_TRANSACTIONS:
            transactionAdapter.removeAll(state);
            return initialTransactionsState;

        case TransactionsActions.TransactionsActionTypes.GET_CASH_TRANSACTIONS_SUCCESS:
            return createTransactionState(state, action.payload)

        case TransactionsActions.TransactionsActionTypes.GET_CASH_TRANSACTIONS:
            return {
                ...createPagingInfo(state),
                transactionActionType: action.payload.transactionActionType
            } 

        case TransactionsActions.TransactionsActionTypes.GET_CASH_TRANSACTIONS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state
    }
}

export function SecurityTransactionsReducer(
    state = initialTransactionsState, action: TransactionsActions.SecurityTransactionsActions | systemActions.SystemActions
): ITransactionsState{
    switch (action.type) {
        case systemActions.CLEAR_SYSTEM:
        case TransactionsActions.TransactionsActionTypes.RESET_SECURITY_TRANSACTIONS:
            transactionAdapter.removeAll(state);
            return initialTransactionsState;

        case TransactionsActions.TransactionsActionTypes.GET_SECURITY_TRANSACTIONS_SUCCESS:
            return createTransactionState(state, action.payload)

        case TransactionsActions.TransactionsActionTypes.GET_SECURITY_TRANSACTIONS:
            return {
                ...createPagingInfo(state),
                transactionActionType: action.payload.transactionActionType
            } 

        case TransactionsActions.TransactionsActionTypes.GET_SECURITY_TRANSACTIONS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state
    }
}

export function RevenueTransactionsReducer(
    state = initialTransactionsState, action: TransactionsActions.RevenueTransactionsActions | systemActions.SystemActions
): ITransactionsState{
    switch(action.type) {
        case systemActions.CLEAR_SYSTEM:
        case TransactionsActions.TransactionsActionTypes.RESET_REVENUE_TRANSACTIONS:
            transactionAdapter.removeAll(state);
            return initialTransactionsState;

        case TransactionsActions.TransactionsActionTypes.GET_REVENUE_TRANSACTIONS_SUCCESS:
            return createTransactionState(state, action.payload)

        case TransactionsActions.TransactionsActionTypes.GET_REVENUE_TRANSACTIONS:
            return {
                ...createPagingInfo(state),
                transactionActionType: action.payload.transactionActionType
            } 
        case TransactionsActions.TransactionsActionTypes.GET_REVENUE_TRANSACTIONS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
             return state
    }
}

function createPagingInfo(oldState: ITransactionsState){
    return {
        ...oldState,
        pagingInfo: {
            ...oldState.pagingInfo,
            pageNumber: oldState.pagingInfo.pageNumber + 1
        },
        loading: true
    }
}

function createTransactionState(oldState: ITransactionsState, transactionResult: ITransactionSearchResult){
    let newState = {
        ...oldState,
        toDate: transactionResult.asAtDate,
        fromDate: transactionResult.fromDate,
        clientEntityIds: transactionResult.clientEntityIds,
        loading: false,
        pagingInfo: {
            ...oldState.pagingInfo,
            totalItemsCount: transactionResult.totalItemCount
        },
    }

    return transactionAdapter.upsertMany(transactionResult.transactionsList, newState);
}